import React, { useState, useMemo } from "react";
import { Button } from "../../../../../components/RegularComponents";

const headers = [
    {
        key: "branchName",
        title: "Branch name",
        sort: (isAscending) => (a, b) =>{
            const aStr = a.branchName
            const bStr = b.branchName
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        } 
    },
    {
        key: "manager",
        title: "Responsible agent",
        sort: (isAscending) => (a, b) => {
            const aStr = `${a.manager.firstName} ${a.manager.lastName}`
            const bStr = `${b.manager.firstName} ${b.manager.lastName}`
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
        format: (manager) => `${manager.firstName} ${manager.lastName ?? ""}`
    },
    {
        key: "address",
        title: "City",
        sort:(isAscending) => (a, b) => {
            const aStr = `${a.address.city}`
            const bStr = `${b.address.city}`
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
        format: (address) => `${address.city ?? "N/A"}`
    },
]

export const BranchesTable = (props) => {
    const { additionalBranches, setBranch } = props;

    const [sortingParameters, setSortingParameters] = useState({})

    const rows = useMemo(() => {
        if(!additionalBranches) { return []}
        const header = headers.find(h => h.key === sortingParameters.key)
        if(!header) { return additionalBranches }

        const newBranches = [...additionalBranches]
        newBranches.sort(header.sort(sortingParameters.isAscending));
        return newBranches

    }, [sortingParameters, additionalBranches])

    const getSortIcon = (header) => {
        if (header.key !== sortingParameters?.key) {
            return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />
        }
        const activeClass = header.key === sortingParameters?.key ? "active" : ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />
    }

    const headerClicked = (header) => () => {
        let modifiedSortingParams = { ...sortingParameters }

        if (header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else {
            modifiedSortingParams = { key: header.key, isAscending: false }
        }

        setSortingParameters(modifiedSortingParams)
    }

    return (
        <div style={{ marginTop: "1em" }}>
            <table>
                <thead>
                    <tr>
                        {headers.map((h) => (
                            <th key={h.key} onClick={headerClicked(h)}>
                                <div style={{
                                    display: "inline-flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    gap: "0.5rem",
                                    alignItems: "center",
                                    cursor: "arrow",
                                    borderRight: "1px solid lightgrey"
                                }}><span>{h.title}</span> <span style={{marginRight: "6px"}}>{getSortIcon(h)}</span></div>
                            </th>
                        ))}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index}>
                            {headers.map((header, headerIndex) => {
                                const key = header.key;
                                const value = row[key]
                                const formattedValue = header.format ? header.format(value) : value;
                                return <td key={headerIndex}>{formattedValue}</td>
                            })}
                            <td>
                                <Button id={`licence-suspension-detail-${index}`}
                                    className={"licence-queue-review-readonly-button"}
                                    buttonType="regular_primary"
                                    text="Details"
                                    onClick={() => {
                                        setBranch(row)
                                    }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    )
}
